import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition';

export default class extends Controller {
  static targets = ["Container", "Background", "Content"]

  initialize() {
    this.open = false
  }

  openModal() {
    if (this.open == false) {
      this.open = true

      this.ContainerTarget.classList.remove("hidden")
      enter(this.BackgroundTarget)
      enter(this.ContentTarget)
    }
  }

  closeModal(e) {
    e.stopPropagation()

    if (this.open) {
      leave(this.BackgroundTarget)
      leave(this.ContentTarget)
      setTimeout(() => {
        this.open = false
        this.ContainerTarget.classList.add("hidden")
      }, 300)
    }
  }

  stopPropagation(e) {
    e.stopPropagation()
  }
}
